import { CSSProperties, ReactElement, ReactNode } from "react";

interface ITabPanelProps {
  children?: ReactNode;
  dir?: string;
  index: any;
  value: any;
  style?: CSSProperties;
}

const TabPanel = (props: ITabPanelProps): ReactElement => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tab-panel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && children}
    </div>
  );
};

export default TabPanel;
